export default __webpack_public_path__ + "madfit-screen@2x.9c3bca8b.png";